(function(){
    angular
        .module('appback')
        .directive('ngSelect2', select2);

        select2.$inject = ['$timeout'];
        function select2($timeout){
            return {
              require: 'ngModel',
              scope:{
                ngModel:"=",
                options:"=",
                extraparams : "=",
                removesearcher : "="
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {

                  //console.log("select2 ",$attrs.name);
                  var options = {};
                  if(scope.options){
                    options = angular.copy(scope.options);
                    //console.log(scope);
                    if(scope.extraparams){
                      var datavar = options.ajax.data({});
                      //console.log(scope.extraparams);
                      options.ajax.data = function(params){
                        datavar.q = params.term;
                        datavar.page = params.page;
                        if($attrs.campos){
                          datavar.field = $attrs.campos;
                        }
                        var objectMerge = angular.merge({}, datavar, scope.extraparams);
                        return objectMerge;
                      }
                    }
                  }
                  //console.log(options);
                  var $element = $(element);
                  if(scope.removesearcher===true){
                    options.minimumResultsForSearch = -1;
                  }

                  //console.log("options",options);
                  $element.select2(options);//.val([{"id":"10","text":"value"}]).trigger("change");

                  //console.log(ngModel.$viewValue);
                  /*if($attrs.nodetype && ngModel.$viewValue!='' && typeof(ngModel.$viewValue) != 'undefined' && ngModel.$viewValue!=0){
                    //$element.select2("data", { id: ngModel.$viewValue, text:'Cargando..' });

                    var valor = ngModel.$viewValue;
                    if(Array.isArray(valor)){
                      var $newOption = $("<option selected='selected'></option>").val(valor[0]).text("Cargando..");
                    }else{
                      var $newOption = $("<option selected='selected'></option>").val(valor).text("Cargando..");
                    }
                    //var $newOption = $("<option selected='selected'></option>").val(valor[0]).text("Cargando..");
                    $element.append($newOption).trigger('change.select2');
                    $.get('/backend/altcrm/content/getvalueselect2',{campo:$attrs.campos,nodetype:$attrs.nodetype,value:valor},function(data){
                      //console.log(data);
                      for(var cont=0;cont<data.length;cont++){
                        //var $newOption = $("<option selected='selected'></option>").val(data[cont].id).text(data[cont].text);
                        if(cont==0){
                          $element.find("option[value='"+data[cont].id+"']").text(data[cont].text);
                        
                        }else{
                          $element.select2("trigger", "select", {
                              data: { id: data[cont].id, text:data[cont].text }
                          })
                        }
                        
                      }    
                      $element.select2(options).trigger('change.select2');
                    },"json");
                  }*/

                    
                    
                    $element.on("select2:open", function (evt) {
                        console.log("select2open");
                      
                      $timeout(function(){
                         document.querySelector('.select2-container--open .select2-search__field').focus();
                      });

                      //self.$search.attr('tabindex', 0);
                      //self.$search.focus(); remove this line
                      //setTimeout(function () { self.$search.focus(); }, 10);//add this line

                    });
                    $element.on("change.select2", function (evt) {
                     // console.log("select2:select");
                    });
                    $element.on("change", function (evt) {
                     // console.log("changesingle");
                      console.log("CHANGE");
                      //ngModel.$setViewValue($element.val());
                    })
                    $element.on("select2:select", function (evt) {
                     // console.log("select2:select ");
                        var elementVar = evt.params.data.element;
                        var $elementVar = $(elementVar);
                        //console.log($element.val());
                        ngModel.$setViewValue($element.val());
                        //console.log(ngModel);
                        /*alert($element.val());
                        $elementVar.detach();
                        $(this).append($elementVar);
                        $(this).trigger("change");*/
                      });

                    function orderSortedValues() {
                        var value = ''
                        $element.parent().find("ul.select2-selection__rendered").children("li[title]").each(function(i, obj){

                            var elM = $element.children('option').filter(function () { return $(this).html() == obj.title });
                            moveElementToEndOfParent(elM)
                        });
                    };
                   function moveElementToEndOfParent(elM) {
                        var parent = elM.parent();
                        elM.detach();
                        parent.append(elM);
                    };

                    function cambiando(){
                     // console.log("CAMBIANDO");
                      //console.log($element);
                      //console.log(scope.ngModel);
                      //console.log(ngModel.$viewValue);
                      if(scope.ngModel==""){
                        //console.log("cambiando");
                        $element.trigger('change.select2');
                      }else{
                        var texto = $element.find("option:selected").text();
                          //console.log("viewvalue",ngModel.$viewValue);
                          //console.log("texto",texto);
                        if(!texto && scope.ngModel && $attrs.campos){
                          //console.log("viewvalue",ngModel.$viewValue);
                          if(Array.isArray(ngModel.$viewValue)){
                            for(var cont=0;cont<ngModel.$viewValue.length;cont++){
                              if(ngModel.$viewValue[cont]!=0){
                                var $newOption = $("<option selected='selected'></option>").val(ngModel.$viewValue[cont]).text("Cargando..");
                                $element.append($newOption).trigger('change.select2');
                              }
                            }
                          }else{
                             if(ngModel.$viewValue!=0){
                               var $newOption = $("<option selected='selected'></option>").val(ngModel.$viewValue).text("Cargando..");
                               $element.append($newOption).trigger('change.select2');
                             }
                          }
                          if(scope.ngModel!=0){
                            $.get('/backend/altcrm/content/getvalueselect2',{ ignoreLoadingBar: true, campo:$attrs.campos,nodetype:$attrs.nodetype,value:scope.ngModel},function(data){
                              //console.log(data);
                              for(var cont=0;cont<data.length;cont++){
                                //var $newOption = $("<option selected='selected'></option>").val(data[cont].id).text(data[cont].text);
                                //if(cont==0){
                                  //console.log("INTENTANDO",data[cont].text);
                                 
                                  $element.find("option[value='"+data[cont].id+"']").text(data[cont].text);
                                  /*$element.select2("trigger", "select", {
                                    data: { id: data[cont].id, text:data[cont].text }
                                  });*/
                                /*}else{
                                  $element.select2("trigger", "select", {
                                      data: { id: data[cont].id, text:data[cont].text }
                                  });
                                }*/
                                /*$element.select2("trigger", "select", {
                                    data: { id: data[cont].id, text:data[cont].text }
                                });*/
                              }    
                              
                              $element.select2(options).trigger('change.select2');
                              if(typeof $attrs.multiple!='undefined'){
                                var ul = $element.parent().find("ul.select2-selection__rendered");
                                ul.sortable({
                                    placeholder : 'ui-state-highlight',
                                    items: '> li.select2-selection__choice',
                                    tolerance   : 'pointer',
                                    update: function() {
                                      console.log("E");
                                      orderSortedValues();
                                        /*$(ul.find('.select2-selection__choice').get().reverse()).each(function() { 
                                            var id = $(this).data('data').id;
                                            var option = $element.find('option[value="' + id + '"]')[0];
                                            $($element).prepend(option);
                                            //$element.trigger("change");
                                        });*/
                                        $element.trigger("change");
                                    }
                                });
                              }

                            },"json");
                          }
                        }else{
                              $element.trigger('change.select2');
                              if(typeof $attrs.multiple!='undefined'){
                                var ul = $element.parent().find("ul.select2-selection__rendered");
                                ul.sortable({
                                    placeholder : 'ui-state-highlight',
                                    items: '> li.select2-selection__choice',
                                    tolerance   : 'pointer',
                                    update: function() {
                                      orderSortedValues();
                                        /*$(ul.find('.select2-selection__choice').get().reverse()).each(function() { 
                                            var id = $(this).data('data').id;
                                            var option = $element.find('option[value="' + id + '"]')[0];
                                            $($element).prepend(option);
                                            //$element.trigger("change");
                                        });*/
                                        $element.trigger("change");
                                    }
                                });
                              }
                        }
                        

                        //$element.trigger('change.select2');
                      }
                    }
                    /*$(element).select2("trigger", "select", {
                        data: { id: ngModel.$viewValue, text:ngModel.$viewValue}
                    },500);*/

                    scope.$watch('ngModel', cambiando, true);

                     console.log("LIST");
                 
                });
            }
          }
      }
})();